<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        :title="form.xjname || '查看学籍'"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack(form.stuid ? ('/stu-main/'+ form.stuid) : '/')"
      />
      <div class="form-info" :style="{'padding-bottom': canUpdate ? '50px' : '0'}">
        <van-form @submit="onSubmit" @failed="onFailed" ref="form">
          <van-cell-group title="学籍信息">
            <van-cell title="状态">
              <van-tag :color="rollStatusColor(form.status)">{{ xjStatus[form.status] ? xjStatus[form.status].name : form.status }}</van-tag>
            </van-cell>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.xjname"
              label="学籍类型"
              :placeholder="canUpdate ? '点击选择学籍类型' : ''"
              @click="showPopup('showXj')"
              :rules="rules.xjname"
              input-align="right"
            />
            <van-popup v-model="showXj" position="bottom">
              <van-picker
                show-toolbar
                :columns="xjList"
                :default-index="xjList.findIndex(d => d.id == form.xjid)"
                value-key="name"
                @change="onChangeXj"
                @confirm="onConfirmXj"
                @cancel="showXj = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.yxname"
              label="院校"
              :placeholder="canUpdate ? '点击选择院校' : ''"
              @click="showPopup('showYx')"
              :rules="rules.yxname"
              input-align="right"
            />
            <van-popup v-model="showYx" position="bottom">
              <van-picker
                show-toolbar
                :columns="yxList"
                :default-index="yxList.findIndex(d => d.id == form.yxid)"
                value-key="name"
                @confirm="onConfirmYx"
                @cancel="showYx = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.ccname"
              label="层次"
              :placeholder="canUpdate ? '点击选择层次' : ''"
              @click="showPopup('showCc')"
              :rules="rules.ccname"
              input-align="right"
            />
            <van-popup v-model="showCc" position="bottom">
              <van-picker
                show-toolbar
                :columns="ccList"
                :default-index="ccList.findIndex(d => d.id == form.ccid)"
                value-key="name"
                @change="onChangeCc"
                @confirm="onConfirmCc"
                @cancel="showCc = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.zyname"
              label="专业"
              :placeholder="canUpdate ? '点击选择专业' : ''"
              @click="showPopup('showZy')"
              :rules="rules.zyname"
              input-align="right"
            />
            <van-popup v-model="showZy" position="bottom">
              <van-picker
                show-toolbar
                :columns="zyList1"
                :default-index="zyList1.findIndex(d => d.id == form.zyid)"
                value-key="name"
                @confirm="onConfirmZy"
                @cancel="showZy = false"
              />
            </van-popup>
            <!-- <van-field
              v-if="form.xjid == '02'"
              v-model="form.ezy"
              label="第二志愿"
              placeholder="输入第二志愿"
            /> -->
            <van-cell v-if="form.xjid == '02'" title="第二志愿" :value="form.ezy" />
            <van-cell v-if="form.nj" title="年级" :value="form.nj" />
            <van-cell v-if="form.cq" title="春/秋季" :value="form.cq" />
            <van-cell title="登记时间" :value="form.createtime" />
            <van-cell title="报名日期" :value="formatDate(form.signdate)" />
            <!-- <van-field
              readonly
              clickable
              name="picker"
              :value="form.prexlname"
              label="前置学历"
              :placeholder="canUpdate ? '点击选择前置学历' : ''"
              @click="showPopup('showXl')"
              :rules="rules.prexlname"
              input-align="right"
            /> -->
            <!-- <van-popup v-model="showXl" position="bottom">
              <van-picker
                show-toolbar
                :columns="xlList"
                value-key="name"
                @confirm="onConfirmXl"
                @cancel="showXl = false"
              />
            </van-popup>
            <van-field v-if="canUpdate" name="uploader" label="上传前置学历照片" input-align="right">
              <template #input>
                <van-uploader v-model="form._xlpic" :after-read="afterRead" :max-count="1" />
              </template>
            </van-field>
            <van-cell v-if="!canUpdate" title="前置学历照片">
              <van-image
                v-if="form.xlpic"
                round
                width="4rem"
                height="4rem"
                :src="form.xlpic ? rootPath + form.xlpic : noimg"
              />
              <div v-if="!form.xlpic">无</div>
            </van-cell> -->
            <!-- <van-field
              v-model="form.note"
              rows="1"
              autosize
              label="备注"
              type="textarea"
              :placeholder="canUpdate ? '输入备注' : ''"
              input-align="right"
            /> -->
          </van-cell-group>
          <div v-if="canUpdate" class="signup-btns">
            <!-- <div v-if="total" class="prices">
              小计：<span class="price" v-html="webPrice(total)"></span>
            </div> -->
            <van-button round block type="info" native-type="submit" :loading="saveLoading" loading-text="更新中...">
              确定更新
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import { deepCopy } from '@/utils/utils';
export default {
  components: {
  },
  mixins: [siteMixin],
  props: {
    id: String
  },
  data() {
    return {
      isLoading: false,
      showXj: false,
      showCc: false,
      showYx: false,
      showZy: false,
      showXl: false,
      form: {},
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      reloadWeb: [types.OTHER.reloadWeb],
      sexList: [types.BASE_LOAD.sexList],
      xjList: [types.BASE_LOAD.xjList],
      ccList: [types.BASE_LOAD.ccList],
      yxList: [types.BASE_LOAD.yxList],
      zyList: [types.BASE_LOAD.zyList],
      xjStatus: [types.BASE_LOAD.xjStatus],
      xlMap: [types.BASE_LOAD.xlMap],
      baseLoading: [types.BASE_LOAD.baseLoading]
    }),
    defaultData() {
      return {
        id: null,
        name: null,
        sex: null,
        sfzh: null,
        mobile: null,
        qq: null,
        weixin: null,
        xjid: null,
        xjname: null,
        ccid: null,
        ccname: null,
        yxid: null,
        yxname: null,
        zyid: null,
        zyname: null,
        prexl: null,
        prexlname: null,
        ezy: null,
        note: null,
      }
    },
    zyList1() {
      if (!this.zyList) {
        return [];
      }
      const xjid = this.form.xjid;
      const yxid = this.form.yxid;
      const ccid = this.form.ccid;
      return this.zyList.filter(d => {
        const xj = xjid ? xjid == d.xjid : true;
        const yx = yxid && d.yxids ? d.yxids.includes(yxid) : true;
        const cc = ccid ? ccid == d.ccid : true;
        return xj && yx && cc;
      });
    },
    xlList() {
      return Object.keys(this.xlMap).map(k => {
        return {code: k, name: this.xlMap[k]};
      });
    },
    canUpdate() {
      return this.form.status == 'DJ';
    },
    rules() {
      return {
        xjname: [{ required: true, message: '请选择学籍类型' }],
        ccname: [{ required: true, message: '请选择层次' }],
        yxname: [{ required: true, message: '请选择院校' }],
        zyname: [{ required: true, message: '请选择专业' }]
      }
    }
  },
  watch: {
    id() {
      this.loadData();
    },
    reloadWeb() {
      this.loadData();
    },
    'baseLoading.xlMap'(val) {
      if (val) {
        if (!this.form.prexl && !this.form.prexlname) {
          this.form.prexlname = this.xlMap[this.form.prexl];
        }
      }
    },
    zyList1: {
      handler: function(val, oldval) {
        if (!oldval || !oldval.length) {
          return;
        }
        if (!val.length) {
          this.form.zyid = null;
          this.form.zyname = null;
        } else {
          if (this.form.zyid) {
            if (!val.some(d => d.id == this.form.zyid)) {
              this.form.zyid = null;
              this.form.zyname = null;
            }
          }
        }
      },
      deep: true
    }
  },
  created () {
    this.loadData();
  },
  methods: {
    loadData(callback) {
      if (!this.sexList || !this.sexList.length) {
        this.$store.dispatch(types.BASE_LOAD.sexList);
      }
      if (!this.xjList || !this.xjList.length) {
        this.$store.dispatch(types.BASE_LOAD.xjList);
      }
      if (!this.ccList || !this.ccList.length) {
        this.$store.dispatch(types.BASE_LOAD.ccList);
      }
      if (!this.yxList || !this.yxList.length) {
        this.$store.dispatch(types.BASE_LOAD.yxList);
      }
      if (!this.zyList || !this.zyList.length) {
        this.$store.dispatch(types.BASE_LOAD.zyList);
      }
      if (!this.xjStatus || !Object.keys(this.xjStatus).length) {
        this.$store.dispatch(types.BASE_LOAD.xjStatus);
      }
      if (!this.xlMap || !Object.keys(this.xlMap).length) {
        this.$store.dispatch(types.BASE_LOAD.xlMap);
      }
      if (!this.id) {
        this.form = Object.assign({}, this.defaultData);
        this.Toast.fail('参数错误！');
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.isLoading = true;
      this.doPost({
        url: 'site/home/getRoll/'+ this.id,
        data: {},
        okcb: (json) => {
          this.form = Object.assign({}, this.defaultData, json, {
            _xlpic: json.xlpic ? [{
              url: this.imgPath(json.xlpic), status: 'done'
            }] : [],
            prexlname: (json.prexl && this.xlMap) ? this.xlMap[json.prexl] : ''
          });
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
          this.Toast.clear();
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    showPopup(t) {
      if (this.canUpdate) {
        this[t] = true;
      }
    },
    onConfirmXj(data) {
      this.form.xjid = data.id;
      this.form.xjname = data.name;
      this.showXj = false;
    },
    onChangeXj(el, data) {
      this.onConfirmXj(data);
    },
    onConfirmCc(data) {
      this.form.ccid = data.id;
      this.form.ccname = data.name;
      this.showCc = false;
    },
    onChangeCc(el, data) {
      this.onConfirmCc(data);
    },
    onConfirmYx(data) {
      this.form.yxid = data.id;
      this.form.yxname = data.name;
      this.showYx = false;
    },
    onConfirmZy(data) {
      this.form.zyid = data.id;
      this.form.zyname = data.name;
      this.showZy = false;
    },
    onConfirmXl(data) {
      this.form.prexl = data.code;
      this.form.prexlname = data.name;
      this.showXl = false;
    },
    // 上传图片
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      this.doUpload4Vant({
        url: this.upload4Web,
        file: file.file,
        okcb: (json) => {
          file.status = 'done';
          file.url = json.pic;
          //console.log(json, file)
        },
        errcb: (json) => {
          //console.log(json)
          file.status = 'failed';
          file.message = json.message || '上传失败！';
        }
      });
    },
    onSubmit(values) {
      // console.log('submit', values);
      //console.log(this.form)
      let postData = deepCopy(this.form);

      // 规范数据
      if (postData._xlpic.length && !postData._xlpic[0].url.startWith('http') && !postData._xlpic[0].url.startsWith('/')) {
        postData.xlpic = postData._xlpic[0].url;
      }
      if (!postData._xlpic.length) {
        postData.xlpic = null;
      }
      postData.version === null ? postData.version = 1 : (postData.version += 1);

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.saveLoading = true;
      this.doPost({
        url: 'site/home/updateRoll',
        data: postData,
        okcb: (json) => {
          this.Dialog.confirm({
            message: '更新成功！',
            showCancelButton: false
          }).then(() => {
            setTimeout(() => {
              this.triggerWeb();
              setTimeout(() => {
                this.loadData();
              }, 3000);
            }, 100);
          });
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    },
    onFailed({ errors }) {
      if (errors.length) {
        this.$refs.form.scrollToField(errors[0].name);
      }
      // console.log(errors)
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-top:46px;
  height:calc(100vh - 46px);
  background-color:#f5f5f5;
  /deep/ .van-field__error-message{
    text-align:right;
  }
}
.roll-item{
  padding:1rem;
  background-color:#fff;
}
.roll-item::before {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background-size: 80px;
  content: '';
}
.signup-btns {
  position:fixed;
  left:50%;
  bottom: .2rem;
  .flex-center-v();
  width: 100%;
  max-width: 750px;
  transform: translateX(-50%);
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .prices {
    margin-right:2rem;
    padding:.5rem 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    background-color:#f0f0f0;
    border-radius:2rem;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>